import { FC } from "react";
import {
  Box,
  TextField as MuiTextField,
  CircularProgress,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import SearchIcon from "./SearchIcon";
import { TCustomTextField } from "./TextField.models";

const TextField: FC<TCustomTextField> = ({
  isFetchingNextPage,
  isFetching,
  isLoading,
  params,
  name,
  label,
  required,
  error,
  invalid,
  fieldRef,
  inputRef,
  search,
  handleClear,
}) => (
  <MuiTextField
    sx={{
      minWidth: "280px",
      padding: 0,
      ".MuiAutocomplete-inputRoot": {
        paddingRight: "10px !important",
      },
    }}
    {...params}
    id={name}
    label={label}
    required={required}
    error={invalid}
    helperText={error?.message}
    inputRef={fieldRef}
    slotProps={{
      inputLabel: {
        ...(!(search.length > 0) && {
          sx: { padding: "0 0 0 32px" },
        }),
        shrink: search.length > 0,
      },
      input: {
        inputRef,
        ...params.InputProps,
        ...(isLoading
          ? {
              startAdornment:
                isFetching || isFetchingNextPage ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null,
            }
          : {
              sx: { padding: 0 },
              startAdornment: (
                <Box>
                  <SearchIcon />
                </Box>
              ),
              endAdornment: (
                <Box>
                  {search !== "" && (
                    <CloseOutlined
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleClear()}
                    />
                  )}
                </Box>
              ),
            }),
      },
    }}
  />
);

export default TextField;
